export default "/corgi/pageapps/prepurchase/_next/static/media/home-24-logo.192e9885.svg";